import React from 'react';
import propTypes from 'prop-types';
export const AddEmployeeIcon = ({ size = 18, color = 'none', variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      fill={color}
      className={variant}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 483.176 483.176"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M225.488,301.56c2.393,2.142,5.464,3.269,8.581,3.269c1.48,0,2.977-0.253,4.41-0.772c4.455-1.622,7.67-5.55,8.361-10.244
		l8.125-54.854c13.56,1.552,24.976,10.794,29.07,24.116l1.967,6.416c5.686-3.078,11.699-5.613,17.873-7.763l-1.322-4.337
		c-6.992-22.794-27.714-38.116-51.557-38.116h-6.928l-18.502-12.148c-1.543-1.023-3.261-1.535-4.992-1.818l-1.26-6.143
		c15.385-11.777,29.289-29.146,37.603-48.996c11.559-4.496,20.897-16.021,24.077-30.344c4.061-18.425-3.086-36.241-16.786-43.445
		C260.321,41.91,246.038,0,180.924,0c-64.608,0-79.095,41.735-83.175,76.143c-13.621,6.945-21.021,25.015-16.896,43.69
		c3.18,14.314,12.519,25.84,24.077,30.336c8.315,19.85,22.22,37.219,37.604,48.996l-1.26,6.143
		c-1.733,0.283-3.449,0.795-4.992,1.818l-18.52,12.148h-6.912c-23.84,0-44.563,15.322-51.555,38.116l-24.518,79.931
		c-4.992,16.289-1.922,34.178,8.203,47.869c10.126,13.693,26.33,21.865,43.367,21.865h140.336c-1.67-6.284-2.961-12.724-3.59-19.369
		h-26.99l10.378-64.616l-12.235-30.936l9.968-9.518L225.488,301.56z M242.682,233.809l-8.613,58.106l-44.105-39.281l28.517-34.714
		L242.682,233.809z M121.291,138.855c-1.18-3.22-3.983-5.566-7.354-6.173c-5.211-0.944-11.873-6.677-14.172-17.039
		c-2.362-10.66,1.686-21.368,8.584-22.855c4.361-0.726,7.666-4.3,8.063-8.692c4.077-45.974,22.77-64.729,64.513-64.729
		c42.565,0,60.673,18.141,64.579,64.688c0.361,4.339,3.574,7.905,7.857,8.709c0.158,0.03,0.33,0.055,0.52,0.079
		c6.677,1.89,10.502,12.369,8.189,22.8c-2.283,10.362-8.945,16.095-14.158,17.039c-3.37,0.606-6.172,2.961-7.352,6.173
		c-12.282,33.28-41.29,56.468-59.635,56.468C162.579,195.323,133.573,172.136,121.291,138.855z M180.924,214.691
		c6.724,0,13.778-1.747,20.819-4.817l1.338,6.44l-10.379,12.645l-11.778,14.329l-11.777-14.329l-10.378-12.645l1.338-6.44
		C167.145,212.944,174.2,214.691,180.924,214.691z M143.368,217.92l28.518,34.714l-44.107,39.281l-8.629-58.106L143.368,217.92z
		 M86.348,387.686c-10.914,0-21.305-5.243-27.809-14.021c-6.473-8.765-8.439-20.235-5.244-30.668l24.518-79.923
		c4.095-13.314,15.495-22.557,29.055-24.108l8.14,54.846c0.692,4.694,3.905,8.622,8.362,10.244c1.434,0.52,2.928,0.772,4.408,0.772
		c3.119,0,6.189-1.127,8.584-3.269l21.273-18.943l9.967,9.518l-12.234,30.936l10.376,64.616H86.348z"
        />
        <path
          d="M343.542,268.774c-59.191,0-107.189,48.005-107.189,107.206c0,59.198,47.998,107.195,107.189,107.195
		c59.209,0,107.205-47.997,107.205-107.195C450.747,316.779,402.751,268.774,343.542,268.774z M382.626,393.206H360.77v21.857
		c0,9.511-7.717,17.226-17.229,17.226c-9.51,0-17.227-7.715-17.227-17.226v-21.857h-21.842c-9.51,0-17.226-7.716-17.226-17.226
		c0-9.513,7.716-17.228,17.226-17.228h21.842v-21.857c0-9.511,7.717-17.227,17.227-17.227c9.512,0,17.229,7.716,17.229,17.227
		v21.857h21.855c9.512,0,17.227,7.715,17.227,17.228C399.852,385.49,392.137,393.206,382.626,393.206z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
AddEmployeeIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
};
AddEmployeeIcon.defaultProps = {
  size: 18,
  color: 'black',
};
